<h2 mat-dialog-title>Add Comment to Chain {{ data.chainNumber }}</h2>

<mat-dialog-content>
  <p class="dialog-description">
    Add a comment to this chain. This comment will be visible in this matchrun only.
  </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Comment</mat-label>
    <textarea
      matInput
      [(ngModel)]="comment"
      rows="4"
      placeholder="Enter your comment here..."
      maxlength="1000"
    ></textarea>
    <mat-hint align="end">{{ comment.length }}/1000</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
  >
    Save Comment
  </button>
</mat-dialog-actions>
